import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Grid } from "@mui/material";
import { OrderSummaryLine } from "./orderSummarySubComponents";
import { DefaultCartText } from "./orderSummary-Types";
/**
 * Displays formatted subscription discount line item
 *
 * @param value - The discount as a percent
 * @param appliedValue - The actual discount amount
 * @returns
 */
export const SubscriptionDiscountSummary = ({ appliedValue, value, showDivider = false, subscriptionDiscountHeader, indent = false, }) => {
    const subDiscountTitle = `${!!(subscriptionDiscountHeader === null || subscriptionDiscountHeader === void 0 ? void 0 : subscriptionDiscountHeader.display) && !!subscriptionDiscountHeader.label
        ? subscriptionDiscountHeader.label
        : DefaultCartText.SUB_DISCOUNT} (${value}%)`;
    const subDiscountValue = -Math.abs(appliedValue);
    return (_jsxs(_Fragment, { children: [_jsx(OrderSummaryLine, { label: subDiscountTitle, value: subDiscountValue, indent: indent }), showDivider && (_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Divider, {}) })))] }));
};
